interface IOptionsSetCookie {
  secure?: boolean;
  sameSite?: "Strict" | "Lax" | "None";
  domain?: string;
}

class CookieManager {
  setCookie = (
    name: string,
    value: any,
    days?: number,
    options?: IOptionsSetCookie
  ) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }

    let cookieString = name + "=" + (value || "") + expires + "; path=/";

    // Append secure attribute if specified
    if (options?.secure) {
      cookieString += "; Secure";
    }

    // Append sameSite attribute if specified
    if (options?.sameSite) {
      cookieString += `; SameSite=${options.sameSite}`;
    }

    // Append domain attribute if specified
    if (options?.domain) {
      cookieString += `; Domain=${options.domain}`;
    }
    console.log(cookieString);

    document.cookie = cookieString;
  };

  removeCookie = (name: string) => {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
    // if(!!String(process.env.PUBLIC_URL)){
    //   const domain = `; domain=.${String(process.env.PUBLIC_URL)}`;
    //   document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/" + domain;
    // }else{
    //   document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
    // }
  };
  getCookie = (cname: string) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

   removeAllCookies = () => {
  document.cookie.split("; ").forEach((cookie) => {
    const [name] = cookie.split("=");

    // Xóa trên các path và domain khác nhau
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;

    ["", `.${location.hostname}`, location.hostname].forEach((domain) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${window.location.pathname}; domain=${domain}`;
    });
  });
};

  
  
  
}

export default new CookieManager();
